import axios from '../axios'

export const selectPage = (data) => {
    return axios({
        url: '/admin/sourceCategory/selectPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/admin/sourceCategory/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/admin/sourceCategory/update',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/sourceCategory/batchEnable',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/sourceCategory/batchDisabled',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/sourceCategory/batchDelete',
        method: 'post',
        data
    })
}

export const selectList = (data) => {
    return axios({
        url: '/admin/sourceCategory/selectList',
        method: 'post',
        data
    })
}

export const initGrab = (data) => {
    return axios({
        url: '/admin/sourceCategory/initGrab',
        method: 'post',
        data
    })
}
export const selectTreeList = (data) => {
    return axios({
        url: '/admin/sourceCategory/selectTreeList',
        method: 'post',
        data
    })
}

export const batchInsert = (data) => {
    return axios({
        url: '/admin/sourceCategory/batchInsert',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sourceCategory.js